import type { FormInstance }     from 'antd';
import React                     from 'react';
import { Col }                   from 'antd';
import { Form }                  from 'antd';
import Row                       from 'components/App/Row';
import Input                     from 'components/App/IntlInput';
import Select                    from 'components/App/IntlSelect';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import { AppFormComponent }      from 'components/App/AppForm';
import handleApiError            from 'utils/handleApiError';
import type { RefObject }        from 'react';
import { ApiCollection }         from 'collections/ApiCollection';
import ProviderShowCategoryModel from 'models/ProviderShowCategoryModel';
import ProviderShowModel         from 'models/ProviderShowModel';
import ProviderModel             from 'models/ProviderModel';
import { messageSuccessIntl }    from 'utils/messageIntl';

const { Option } = Select;

interface ProviderShowFormProps {
  model: ProviderShowModel;
  onSuccess?: (model: ProviderShowModel) => void;
  providerCollection: ApiCollection<ProviderModel>;
  providerShowCategory: ProviderShowCategoryModel;
  providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;
}

class ProviderShowForm extends AppFormComponent<ProviderShowFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public render() {
    const {
      model,
      providerCollection,
      providerShowCategory,
      providerShowCategoryCollection,
    } = this.props;

    return (
      <Form
        className="antd-form-custom-style"
        initialValues={{
          link: model.link,
          provider: model.providerIri,
          providerShowCategory: providerShowCategory.iri,
        }}
        ref={this.formRef}
      >
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Catégorie" />}
              labelCol={{ span: 24 }}
              name="providerShowCategory"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Catégorie manquante" />,
                  required: true,
                },
              ]}
            >
              <Select disabled>
                {providerShowCategoryCollection.map((psc: ProviderShowCategoryModel) => (
                  <Option
                    key={psc.id}
                    value={psc.iri}
                  >
                    {psc.providerShowCategoryName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Prestataire" />}
              labelCol={{ span: 24 }}
              name="provider"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Prestataire manquant" />,
                  required: true,
                },
              ]}
            >
              <Select
                onChange={(value: string) => {
                  const providerFound = providerCollection.find(
                    provider => provider.get('@id') === value,
                  );
                  if (providerFound) {
                    this.formRef.current?.setFieldsValue({
                      link: providerFound.get('link'),
                    });
                  }
                }}
              >
                {providerCollection.map(provider => (
                  <Option key={provider.id} value={provider.get('@id')}>
                    {provider.get('name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col lg={24} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Lien" />}
              labelCol={{ span: 24 }}
              name="link"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Lien manquant" />,
                  required: false,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const values = await this.formRef.current?.validateFields();

    try {
      await this.handleSubmit(values);
    } catch (error) {
      handleApiError(error);
    }
  };

  private handleSubmit = async (values: any) => {
    const {
      model,
      onSuccess,
    } = this.props;

    model.set(values);
    await model.save();
    messageSuccessIntl("Prestataire enregistré !");

    if (onSuccess) {
      onSuccess(model);
    }

    this.formRef.current?.resetFields();
  };
}

export default ProviderShowForm;
